module.exports = __webpack_public_path__ + "static/media/backArrow.d41c37f3.svg";